module.exports = __webpack_public_path__ + "img/car2.7534b9ef.png";